export const CONNECT_CLIENT_SITE = 'connect_client_site';
export const OPEN_DOCUMENTATION = 'open_documentation';
